// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class RngConfig implements flatbuffers.IUnpackableObject<RngConfigT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RngConfig {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRngConfig(bb:flatbuffers.ByteBuffer, obj?:RngConfig):RngConfig {
  return (obj || new RngConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRngConfig(bb:flatbuffers.ByteBuffer, obj?:RngConfig):RngConfig {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RngConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

str():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 10;
}

crit():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 10;
}

seed():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

state():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

static startRngConfig(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addStr(builder:flatbuffers.Builder, str:number) {
  builder.addFieldInt8(0, str, 10);
}

static addCrit(builder:flatbuffers.Builder, crit:number) {
  builder.addFieldInt8(1, crit, 10);
}

static addSeed(builder:flatbuffers.Builder, seed:number) {
  builder.addFieldInt32(2, seed, 0);
}

static addState(builder:flatbuffers.Builder, state:number) {
  builder.addFieldInt32(3, state, 0);
}

static endRngConfig(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRngConfig(builder:flatbuffers.Builder, str:number, crit:number, seed:number, state:number):flatbuffers.Offset {
  RngConfig.startRngConfig(builder);
  RngConfig.addStr(builder, str);
  RngConfig.addCrit(builder, crit);
  RngConfig.addSeed(builder, seed);
  RngConfig.addState(builder, state);
  return RngConfig.endRngConfig(builder);
}

unpack(): RngConfigT {
  return new RngConfigT(
    this.str(),
    this.crit(),
    this.seed(),
    this.state()
  );
}


unpackTo(_o: RngConfigT): void {
  _o.str = this.str();
  _o.crit = this.crit();
  _o.seed = this.seed();
  _o.state = this.state();
}
}

export class RngConfigT implements flatbuffers.IGeneratedObject {
constructor(
  public str: number = 10,
  public crit: number = 10,
  public seed: number = 0,
  public state: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return RngConfig.createRngConfig(builder,
    this.str,
    this.crit,
    this.seed,
    this.state
  );
}
}
